import { FixedCostsBudgetPolicy, SubOrderRequest } from "../../../api";
import { settingsSelector } from "../../../shared/selectors";
import { getSpotPrices } from "../../../utils";
import { useAppSelector } from "../../../utils/hooks";
import { BudgetBonusValidationConfiguration } from "./partials/BudgetBonusFormSection";

type FixedCostSubOrderInstanceSettings = {
  validationConfigs: BudgetBonusValidationConfiguration;
};

const useFixedCostsSubOrderSettings = () => {
  const settings = useAppSelector(settingsSelector);

  // Minimum nr of breaks allowed
  const requireBreaks =
    settings?.fixedCostsBudgetPolicy ===
    FixedCostsBudgetPolicy.IsBreakSelectionSpotPrice;

  // Check if budget is editable
  const isEditableBudget =
    settings?.fixedCostsBudgetPolicy ===
    FixedCostsBudgetPolicy.IsEqualOrHigherThanBreakSelection;

  // Fixed costs
  const getMinimumBudget = ({
    breakSelection,
    _package,
  }: Partial<SubOrderRequest>) =>
    getSpotPrices(breakSelection, _package?.preferredPositionSurcharge ?? 0);

  const getMaximumBonus = ({ budget }: Partial<SubOrderRequest>) => budget ?? 0;

  // Generate context for this sub order
  const createInstanceSettings = (
    subOrder: Partial<SubOrderRequest>
  ): FixedCostSubOrderInstanceSettings => ({
    validationConfigs: {
      budget: {
        minimum: getMinimumBudget(subOrder),
      },
      bonus: {
        minimum: 0,
        maximum: getMaximumBonus(subOrder),
      },
    },
  });

  return {
    requireBreaks,
    isEditableBudget,
    createInstanceSettings,
  };
};

export default useFixedCostsSubOrderSettings;
